import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotAuthorized from './../layout/NotAuthorized'

function Auth({authorizedPersonas = [], children}) {
    const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");

    if(authorizedPersonas.includes(userInfo?.description?.trim())) {
        return (
            children
        )
    }
    return <NotAuthorized />   
}

export default Auth